export const isValidButtonInputEvent = (e, disabledKeyCodes = []) => {
  if (
    (e?.nativeEvent.type === 'click' ||
      e?.keyCode === 32 ||
      e?.keyCode === 13) &&
    !disabledKeyCodes.includes(e?.keyCode)
  ) {
    e.preventDefault();
    return true;
  }
  return false;
};
